var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatchiignore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 11,
    fill: "url(#paint0_linear_4819_3950)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5351 58.0375L44.548 57.0752L44.5479 57.0749L45.5351 58.0375Z",
    fill: "#377DE2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4819_3950)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9062 34.574C43.7067 34.574 42.5536 34.7775 41.4837 35.1537C40.5679 34.7436 39.5751 34.3859 38.5946 34.093L36.5596 33.5843C36.2266 33.4948 35.9583 33.3746 35.7363 33.2204C36.4794 32.9337 37.2718 32.6901 38.0396 32.5174C39.8187 31.9624 40.5124 30.5102 40.5124 29.061C39.3901 28.0589 45.7972 28.0589 44.6749 29.061C44.6749 30.5102 45.3687 31.9624 47.1477 32.5174C49.1827 32.9707 51.412 33.9358 52.3432 34.9193C52.9475 35.5175 52.9999 35.943 52.9999 37.6604C52.9999 37.867 52.9413 38.0767 52.8396 38.2678C50.931 36.0078 48.082 34.574 44.9062 34.574Z",
    fill: "#FF7705",
    fillOpacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4869 27.3467C38.9063 25.9746 39.1252 24.6333 39.1252 23.5018C39.1252 21.7288 38.6719 20.0392 37.8672 18.5715C38.9155 17.0175 40.6422 16 42.5939 16C45.7821 16 48.3752 18.7195 48.3752 22.068C48.3752 25.4227 45.7821 30.1618 42.5939 30.1618C40.9875 30.1618 39.5353 28.9654 38.4869 27.3467Z",
    fill: "#FF7705",
    fillOpacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 41.8908C16 39.8373 16.0678 39.3254 16.8818 38.6101C18.1152 37.4353 21.0906 36.2853 23.8039 35.7364C25.8328 35.1752 26.8009 33.8217 27.0383 32.3571C24.6241 30.4793 22.9375 26.508 22.9375 23.4709C22.9375 19.3454 26.0455 16 29.8688 16C33.7014 16 36.8125 19.3454 36.8125 23.4709C36.8125 26.508 35.1259 30.4732 32.7055 32.354C32.9429 33.8186 33.9142 35.1752 35.9461 35.7364C36.8834 35.9276 37.8547 36.1897 38.7735 36.5011C36.4764 38.1784 34.8916 40.7777 34.5617 43.75H18.1337C17.0699 43.75 16 42.8188 16 41.8908Z",
    fill: "#E60000",
    fillOpacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8066 44.9063C36.8066 40.4447 40.4357 36.8187 44.9066 36.8187C49.3743 36.8187 53.0065 40.4447 53.0065 44.9063C53.0065 49.3709 49.3743 52.9938 44.9066 52.9938C40.4357 52.9938 36.8066 49.3709 36.8066 44.9063ZM50.694 44.9063C50.694 41.7243 48.1009 39.1312 44.9066 39.1312C41.7091 39.1312 39.1191 41.7243 39.1191 44.9063C39.1191 48.0913 41.7091 50.6813 44.9066 50.6813C48.1009 50.6813 50.694 48.0913 50.694 44.9063Z",
    fill: "#BC0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7156 48.1314C41.3518 47.7707 41.3487 47.1848 41.7064 46.8241L43.5749 44.934L41.7064 43.0408C41.3487 42.6801 41.3518 42.0943 41.7156 41.7335C42.0764 41.3758 42.6622 41.3789 43.023 41.7428L44.8761 43.6205L46.7322 41.7428C47.093 41.3789 47.6788 41.3758 48.0396 41.7335C48.4034 42.0943 48.4065 42.6801 48.0488 43.0408L46.1772 44.934L48.0488 46.8241C48.4065 47.1848 48.4034 47.7707 48.0396 48.1314C47.6788 48.4891 47.093 48.486 46.7322 48.1222L44.8761 46.2475L43.023 48.1222C42.6622 48.486 42.0764 48.4891 41.7156 48.1314Z",
    fill: "#BC0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4819_3950",
    x1: 33.5,
    y1: 0,
    x2: 33.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4819_3950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchiignore);
export default __webpack_public_path__ + "static/media/MATCHIIGNORE.d8f032809dcb92e9572225418e7e800b.svg";
export { ForwardRef as ReactComponent };